import styled from 'styled-components';

export const ImgStyled = styled.img`
  /* width: 100%;
    height: 100%;
    display: block; */
  &:not(.simple) {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
  }
  &.simple {
    height: 100%;
    width: 100%;
  }
`;

export const Content = styled.div`
  height: 100%;
  &.error {
    position: relative;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: url('/images/error.png') no-repeat 50%;
      /* background-size: 25px auto; */
    }
  }
`;
